module.exports = __webpack_public_path__ + "static/img/底部按钮.2ae3a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/底部按钮.png
// module id = Y2Lr
// module chunks = 1